export var CHANGE_CHANNEL = '[CHANNEL] CHANGE';
export var UPDATE_CHANNEL_LIST = 'UPDATE_CHANNEL_LIST';
export var changeChannel = function (id) { return function (dispatch) {
    return dispatch({
        type: CHANGE_CHANNEL,
        payload: {
            id: id,
        },
    });
}; };
export var updateChannelList = function (channelList) { return function (dispatch) {
    return dispatch({
        type: UPDATE_CHANNEL_LIST,
        payload: {
            channelList: channelList,
        },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/channel.actions.ts
// module id = 347
// module chunks = 81